import React from 'react'
import '../../../styles/containers/Prayer/components/skip-modal.scss';
import {ReactComponent as SkipArrow} from '../../../assets/skip-arrow.svg';
import {ReactComponent as WhiteTick} from '../../../assets/white-tick.svg';
import {ReactComponent as RedCross} from '../../../assets/red-cross.svg';
import useMoengage from '../../../hooks/useMoengage';
import {useEffect, useState} from 'react'
import axios from 'axios';

function SkipModal() {

    const trackEvent = useMoengage()[1];
    const [isPayroll, setIsPayroll] = useState(false);
    const [userId, setUserId] = useState('');
    async function fetchUserPayrollOrNotInfo(endPoint, query) {
        var config = {
            method: 'get',
            url: `${process.env.REACT_APP_API_HOST}/v2/app/${endPoint}?${query}`,
            headers: { 
              'Content-Type': 'application/json',
              'Access-Control-Allow-Credentials':'true',
              'Access-Control-Allow-Methods':'GET,HEAD,OPTIONS,POST,PUT',
              'Access-Control-Allow-Headers':'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
              "Cache-Control": null,
              "X-Requested-With": null  
            },
        };
          
        return axios(config).then((response) => {
            if(response.status === 200) {
                return response.data;
            } else {
              throw new Error('Server Error');
            }
        })
    }
    useEffect(() => {
        const paramString = window.location.href.split('?')[1];
        const queryString = new URLSearchParams(paramString);
        let userIdParam;
        queryString.forEach((value, key) => {
            if (key === 'userId') userIdParam = value;
        });
        setUserId(userIdParam);
        fetchUserPayrollOrNotInfo('checkPayrolluserOrNot', `userId=${userIdParam}`)
            .then((userData) => {
                setIsPayroll(userData.isPayrollUser);
            })
            .catch(e => {
                console.log(e.toString());
            })
    }, [])

    const redirectToPage = () => {
        const paramString = window.location.href.split('?')[1];
        const queryString = new URLSearchParams(paramString);
        let userIdParam;
        queryString.forEach((value, key) => {
          if (key === 'userId') userIdParam = value;
        });
        if(isPayroll == true){
            setTimeout(() => window.location.href = `https://mitra.vahan.co/payroll/view-earnings`,1000);
        }
        else{
            setTimeout(() => window.location.href = `https://mitra.vahan.co/non-payroll?userId=${userIdParam}`,1000);
        }
    }
    const handleRemindYesClick = () => {
        trackEvent('worship_skipped', {
            disabled: false
        });
        redirectToPage();
    }
    const handleRemindNeverClick = () => {
        trackEvent('worship_skipped', {
            disabled: true
        });
        redirectToPage();
    }
    return (
        <> 
            <button type="button" className="skip-button d-flex justify-content-between" data-bs-toggle="modal" data-bs-target="#exampleModal">
                <div>Skip</div><SkipArrow/>
            </button>
            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content  __modal-container">
                <div className="modal-body __modal-body d-flex flex-column justify-content-center align-items-center">
                    <div className='d-flex justify-content-center __modal-text'>Do you want to be reminded to pray again?</div>
                    <div className='d-flex justify-content-between' style={{width: '80%'}}>
                        <button className='d-flex justify-content-around align-items-center remind-never-button' data-bs-dismiss="modal" onClick={handleRemindNeverClick}>
                            <RedCross/>
                            <div>Never</div>
                        </button>
                        <button className='d-flex justify-content-around align-items-center remind-yes-button' data-bs-dismiss="modal" onClick={handleRemindYesClick}>
                            <WhiteTick/>
                            <div>Yes</div>
                        </button>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </>
    );
}

export default SkipModal;